import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Ukrainian translations
import ukCommon from '../locales/uk/common.json';
import ukLogin from '../locales/uk/login.json';
import ukDashboard from '../locales/uk/dashboard.json';
import ukChat from '../locales/uk/chat.json';
import ukSettings from '../locales/uk/settings.json';
import ukComponents from '../locales/uk/components.json';
import ukReceipts from '../locales/uk/receipts.json';
import ukScans from '../locales/uk/scans.json';
import ukCalculator from '../locales/uk/calculator.json';

// English translations
import enCommon from '../locales/en/common.json';
import enLogin from '../locales/en/login.json';
import enDashboard from '../locales/en/dashboard.json';
import enChat from '../locales/en/chat.json';
import enSettings from '../locales/en/settings.json';
import enComponents from '../locales/en/components.json';
import enReceipts from '../locales/en/receipts.json';
import enScans from '../locales/en/scans.json';
import enCalculator from '../locales/en/calculator.json';

// Russian translations
import ruCommon from '../locales/ru/common.json';
import ruLogin from '../locales/ru/login.json';
import ruDashboard from '../locales/ru/dashboard.json';
import ruChat from '../locales/ru/chat.json';
import ruSettings from '../locales/ru/settings.json';
import ruComponents from '../locales/ru/components.json';
import ruReceipts from '../locales/ru/receipts.json';
import ruScans from '../locales/ru/scans.json';
import ruCalculator from '../locales/ru/calculator.json';

const resources = {
  uk: {
    common: ukCommon,
    login: ukLogin,
    dashboard: ukDashboard,
    chat: ukChat,
    settings: ukSettings,
    components: ukComponents,
    receipts: ukReceipts,
    scans: ukScans,
    calculator: ukCalculator,
  },
  en: {
    common: enCommon,
    login: enLogin,
    dashboard: enDashboard,
    chat: enChat,
    settings: enSettings,
    components: enComponents,
    receipts: enReceipts,
    scans: enScans,
    calculator: enCalculator,
  },
  ru: {
    common: ruCommon,
    login: ruLogin,
    dashboard: ruDashboard,
    chat: ruChat,
    settings: ruSettings,
    components: ruComponents,
    receipts: ruReceipts,
    scans: ruScans,
    calculator: ruCalculator,
  },
};

const savedLanguage = localStorage.getItem('language');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage || 'en',
    fallbackLng: 'en',
    supportedLngs: ['uk', 'en', 'ru'],
    load: 'languageOnly',
    defaultNS: 'common',
    ns: ['common', 'login', 'dashboard', 'chat', 'settings', 'components', 'receipts', 'scans', 'calculator'],

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
